/*###########################################################################
// Retailers Map
//#########################################################################*/

import { scrollTo } from "../utilities/_scrollTo"

window.retailersMap = {
	config: {
		retailersResults: '.retailers-results'
	},

	elements: {},

	map: null,
	mapId: null,
	noTarget: false,

	init(isRequest = false) {
		const self = this

		self.elements.retailersResults = document.querySelector(self.config.retailersResults)

		if (self.elements.retailersResults !== null) {
			self.mapId = self.elements.retailersResults.getAttribute('data-map-id')

			self.handleRetailersMap(isRequest)
		}
	},

	handleRetailersMap(isRequest) {
		const self = this

		self.map = googleMaps.getMap(self.mapId)
		googleMaps.init(self.mapId)

		if (isRequest) {
			setTimeout(function() {
				const offsetAmount = document.querySelector('.header').clientHeight + 40
				scrollTo(self.elements.retailersResults, -offsetAmount)
			}, 500)
		} else {
			setTimeout(function () {
				if (self.elements.retailersResults !== null) {
					new google.maps.places.Autocomplete(
						document.getElementById('target'),
						{
							types: ['geocode'],
							componentRestrictions: { country: 'uk' }
						}
					);
				}
			}, 150)
		}
	},

	kill() {
		const self = this

		self.map = null
		self.mapId = null
		self.elements = {}
	}
}
